<template>
 <div class="yj-model-mask" v-show="isYjmodeldialog">
      <div class="yj-model-dialog">
        <div class="yj-model-hd">
          <svg t="1741491612942" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="7830" width="25" height="25"><path d="M998.4 353.28h-97.28c-10.24 0-20.48-7.68-20.48-20.48s7.68-20.48 20.48-20.48H998.4c10.24 0 20.48 7.68 20.48 20.48s-7.68 20.48-20.48 20.48zM998.4 709.12h-97.28c-10.24 0-20.48-7.68-20.48-20.48s7.68-20.48 20.48-20.48H998.4c10.24 0 20.48 7.68 20.48 20.48s-7.68 20.48-20.48 20.48zM686.08 143.36c-10.24 0-20.48-7.68-20.48-20.48V28.16c0-10.24 7.68-20.48 20.48-20.48s20.48 7.68 20.48 20.48v97.28c0 10.24-7.68 20.48-20.48 20.48zM332.8 143.36c-10.24 0-20.48-7.68-20.48-20.48V28.16c0-10.24 7.68-20.48 20.48-20.48s20.48 7.68 20.48 20.48v97.28c0 10.24-7.68 20.48-20.48 20.48zM686.08 1016.32c-10.24 0-20.48-7.68-20.48-20.48v-97.28c0-10.24 7.68-20.48 20.48-20.48s20.48 7.68 20.48 20.48v97.28c0 10.24-7.68 20.48-20.48 20.48zM332.8 1016.32c-10.24 0-20.48-7.68-20.48-20.48v-97.28c0-10.24 7.68-20.48 20.48-20.48s20.48 7.68 20.48 20.48v97.28c0 10.24-7.68 20.48-20.48 20.48zM386.56 581.12l-25.6 58.88h-46.08l115.2-261.12h46.08L591.36 640h-46.08l-25.6-58.88h-130.56z m66.56-156.16l-48.64 115.2h99.84l-48.64-115.2zM624.64 640V378.88h43.52V640h-43.52zM120.32 353.28H25.6c-10.24 0-20.48-7.68-20.48-20.48s7.68-20.48 20.48-20.48h97.28c10.24 0 20.48 7.68 20.48 20.48s-7.68 20.48-20.48 20.48zM120.32 709.12H25.6c-10.24 0-20.48-7.68-20.48-20.48s7.68-20.48 20.48-20.48h97.28c10.24 0 20.48 7.68 20.48 20.48s-7.68 20.48-20.48 20.48z" p-id="7831"></path><path d="M803.84 852.48h-588.8c-25.6 0-46.08-20.48-46.08-46.08v-588.8c0-25.6 20.48-46.08 46.08-46.08h591.36c25.6 0 46.08 20.48 46.08 46.08v591.36c0 25.6-20.48 46.08-46.08 46.08zM215.04 209.92c-2.56 0-5.12 2.56-5.12 5.12v591.36c0 2.56 2.56 5.12 5.12 5.12h591.36c2.56 0 5.12-2.56 5.12-5.12v-588.8c0-2.56-2.56-5.12-5.12-5.12H215.04zM998.4 529.92h-97.28c-10.24 0-20.48-7.68-20.48-20.48s7.68-20.48 20.48-20.48H998.4c10.24 0 20.48 7.68 20.48 20.48s-7.68 20.48-20.48 20.48zM509.44 143.36c-10.24 0-20.48-7.68-20.48-20.48V28.16c0-10.24 7.68-20.48 20.48-20.48s20.48 7.68 20.48 20.48v97.28c0 10.24-7.68 20.48-20.48 20.48zM509.44 1016.32c-10.24 0-20.48-7.68-20.48-20.48v-97.28c0-10.24 7.68-20.48 20.48-20.48s20.48 7.68 20.48 20.48v97.28c0 10.24-7.68 20.48-20.48 20.48zM120.32 529.92H25.6c-10.24 0-20.48-7.68-20.48-20.48s7.68-20.48 20.48-20.48h97.28c10.24 0 20.48 7.68 20.48 20.48s-7.68 20.48-20.48 20.48z" p-id="7832"></path></svg>
          <div class="model-type">
            <span>{{llmName}} 响应</span>
          </div>
          <h3></h3>
          <button type="button" class="closed" @click="isYjmodeldialog=false" ><svg  viewBox="0 0 20 20" focusable="false" aria-hidden="true"><path  d="M12.72 13.78a.75.75 0 1 0 1.06-1.06l-2.72-2.72 2.72-2.72a.75.75 0 0 0-1.06-1.06l-2.72 2.72-2.72-2.72a.75.75 0 0 0-1.06 1.06l2.72 2.72-2.72 2.72a.75.75 0 1 0 1.06 1.06l2.72-2.72 2.72 2.72Z"></path></svg></button>
        </div>
        <div class="yj-model-bd">
          <div class="yj-model-bd_warp" >
              <div class="yj-model-panel" v-if="aiRunningState!='pending'">
                  <div class="code-layout" id="chat-container" >
                    <pre><code class="language-json" ref="jsonCode" >{{aicontext}}</code></pre>
                  </div>
              </div>
              <section class="empty-warp" v-else>
                <div class="empty-context">
                  <div class="empty-images">
                    <div class="btn-list">
                    <svg t="1741510756725" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="14328" width="50" height="50"><path d="M958.17 447.4L760.69 249.92l-65.82 65.83 197.47 197.47L694.87 710.7l65.82 65.82 197.48-197.47 65.83-65.83zM263.3 249.92L65.82 447.4 0 513.22l65.82 65.83L263.3 776.52l65.82-65.82-197.47-197.48 197.47-197.47zM343.247 949.483L590.96 52.19l89.72 24.768-247.713 897.295z" fill="#231815" p-id="14329"></path></svg>
                    </div>
                  </div> 
                  <div class="empty-tips">
                    <h2>Ai 响应完成后，将自动完成处理。</h2> 
                    <p>处理速度根据内容长度决定，处理过程中请忽关闭，完成处理后会自动关闭.</p>
                  </div>
                </div>
              </section>
          </div>
        </div>
        <div class="yj-model-ft">
          <div class="operate">
            <Button type="primary ai-primary" :class="{'ai-loading':aiLoading}" @click="startAi"  :disabled="aiLoading">
              <svg  t="1741429323500" class="icon" viewBox="0 0 1218 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="74098" ><path d="M326.183722 206.500257c19.568414 0 36.788619 9.523295 47.529504 24.177863a41.528523 41.528523 0 0 1 17.394146 18.698707l1.348046 3.391858 249.910392 711.072687c8.088278 22.916787-6.348863 48.529667-32.17917 57.22674-24.525746 8.262219-50.529994-1.652444-60.009803-22.351478l-1.304561-3.348373-64.793194-184.247491H160.460996l-64.706223 184.247491c-8.088278 22.916787-35.527543 34.440409-61.314364 25.699851-24.569231-8.262219-38.788945-31.787802-33.222819-53.791396l1.000164-3.47883L252.08466 252.81217a43.267938 43.267938 0 0 1 30.439756-26.91744A58.574787 58.574787 0 0 1 326.140237 206.500257h0.043485z m459.553336 201.511181c25.960763 0 47.225106 12.958639 49.312404 29.396106l0.130456 2.609122v549.046217c0 17.698544-22.177536 32.005229-49.44286 32.005229-25.960763 0-47.225106-12.915153-49.268918-29.396107l-0.217427-2.609122V440.060152c0-17.698544 22.177536-32.005229 49.486345-32.005229zM322.226554 350.741212l-127.760002 363.494165h255.563489L322.226554 350.697727zM1038.430514 105.52724a14.958966 14.958966 0 0 1 9.697236 9.56678l38.658489 117.801853 120.889315 42.87657a14.958966 14.958966 0 0 1-0.869708 28.482914l-118.410648 33.266304-36.658163 116.018954a14.958966 14.958966 0 0 1-28.439428 0.130456l-38.701975-117.758368-117.323515-37.223473a14.958966 14.958966 0 0 1-0.217426-28.395943l115.975468-39.049858 36.658162-115.975468a14.958966 14.958966 0 0 1 18.742193-9.740721zM772.387051 0.553569a10.436488 10.436488 0 0 1 6.653261 6.827202l22.04708 70.489776 72.490103 24.569232a10.436488 10.436488 0 0 1-0.391368 19.959782l-72.185706 21.48177-23.569067 70.794174a10.436488 10.436488 0 0 1-19.872812-0.173941l-22.04708-70.489777-70.228865-21.220858a10.436488 10.436488 0 0 1-0.434853-19.872811l70.794174-24.873629 23.525582-70.881145a10.436488 10.436488 0 0 1 13.219551-6.609775z" p-id="74099"></path></svg>
              <span v-if="aiRunningState=='pending'">开始处理</span>
              <span v-else-if="aiRunningState=='progress'">处理中</span>
              <span v-else-if="aiRunningState=='completed'">完成处理</span>
            </Button>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
    import FetchInterceptor from '@/api/fetchHttp';
    import hljs from "highlight.js";
    import "highlight.js/styles/github.css"; // 主题
    export default {
        inject: ['parentContext'],
        name: 'llmsTask',
          data () {
            return {
                isYjmodeldialog:true,
                aiLoading:false,
                aiRunningState:'pending',//pending\progress\completed\error
                aicontext:"",
            }
          },
        props: {
            apiUrl: {
                  type: String,
                  default: 'default'
            },
            llmName: {
                  type: String,
                  default: 'default'
            },
            onOk:{
                type:Function
            },
        },
        computed: {
         
        },
        methods: {
            async startAi(){
                if(this.aiRunningState!=='pending') return;
                this.aiLoading=true
                this.aiRunningState="progress"
                try {
                const reader = await FetchInterceptor.streamRequest(this.apiUrl, {}, this.parentContext);
                if (reader.read) {
                    const decoder = new TextDecoder();
                    let textBuffer = ""; // 用于存储未完整解析的数据
                    let chatPopup = document.getElementById("chat-container");
                    let isUserScrolling = false; // 记录用户是否手动滚动
                    // 监听滚动事件，用户手动滚动时暂停自动滚动
                    chatPopup.addEventListener("scroll", () => {
                        let isAtBottom = chatPopup.scrollHeight - chatPopup.scrollTop <= chatPopup.clientHeight + 10;
                        isUserScrolling = !isAtBottom;
                    });
                    while (true) {
                        const { done, value } = await reader.read();
                        if (done) {this.aiLoading=false;this.aiRunningState="pending";break;}
                            let chunk = decoder.decode(value, { stream: true });
                            textBuffer += chunk; // 累积数据
                            //console.log("收到数据块:", chunk); // 调试数据
                            // 按换行符拆分，SSE 事件是逐行返回的
                            let lines = textBuffer.split("\n");
                            textBuffer = lines.pop(); // 剩余部分可能是不完整的数据
                            for (let line of lines) {
                                //console.log("解析行:", line); // 观察解析的每一行
                                if (line.startsWith("data:")) {
                                    let jsonStr = line.replace("data:", "").trim();
                                    if (jsonStr === "[DONE]") 
                                    {
                                            this.$nextTick(() => {
                                            const codeBlock = this.$refs.jsonCode;
                                            if (codeBlock) {
                                                //codeBlock.removeAttribute("data-highlighted"); // 先移除高亮标记
                                                hljs.highlightElement(codeBlock); // 重新高亮
                                            }
                                        }); 
                                        this.aiRunningState="completed"
                                        this.aiLoading=false
                                        this.autoPostAiResult();
                                        return;
                                    }
                                    try {
                                        let jsonData = JSON.parse(jsonStr);
                                        if (jsonData.choices && jsonData.choices.length > 0) {
                                            let content = jsonData.choices[0].delta.content || "";
                                            this.aicontext += content; // 逐步添加文本
                                            this.$nextTick(() => {
                                                if (!chatPopup) return;
                                                if (!isUserScrolling) { // 仅当用户未手动滚动时自动滚动
                                                    chatPopup.scrollTo({ top: chatPopup.scrollHeight, behavior: "smooth" });
                                                }
                                            });
                                        }
                                    } catch (e) {
                                    //this.aiLoading=false;
                                        console.error("JSON 解析失败:", e, jsonStr);
                                    }
                                }
                        }
                    }
                    }else{
                    this.aiLoading=false;
                    this.aiRunningState="pending"
                    this.$Message.error(reader.message);
                    //console.error("Reader is invalid", reader);
                    }
                }catch (error) {
                console.error("Stream error:", error);
                this.aiLoading=false;
                this.aiRunningState="pending"
                this.$Message.error("Stream error:", error);
            }
            
            },
            //Ai重新翻译
            AiTranslation:function(){
                this.aiLoading=false,
                this.aicontext=""
                this.aiRunningState="pending"
                this.isYjmodeldialog=true;
                return;
            },
            //提交ai处理后的结果
            autoPostAiResult(){
                this.onOk({data:this.aicontext})
                setTimeout(()=>{
                    this.aiLoading=false,
                    this.aicontext=""
                    this.aiRunningState="pending"
                    this.isYjmodeldialog=false;
                },3000)
            }
        }
    };
</script>

<style scoped>


  .yj-model-mask { position: fixed; top: 0; left: 0; width: 100%; height: 100%; z-index: 99999; background-color: rgba(0, 0, 0, 0.55); display: -moz-box; -moz-box-pack: center; -moz-box-align: center; display: -webkit-box; -webkit-box-pack: center; -webkit-box-align: center; display: box; box-pack: center; box-align: center; }
  .yj-model-dialog { display: flex; flex-direction: column; white-space: normal; -webkit-border-radius: 4px; border-radius: 4px; background-color: #FFFFFF; -webkit-box-shadow: 0 1px 20px 0 rgba(0, 0, 0, 0.1); box-shadow: 0 1px 20px 0 rgba(0, 0, 0, 0.1); width: 980px; min-height: 600px; min-width: 600px; box-sizing: border-box; }
  .yj-model-dialog .yj-model-hd { display: flex; gap: 6px; justify-content: center; align-items: center; padding: 0 32px; line-height: 72px; height: 72px; }
  .yj-model-dialog .yj-model-hd h3 { flex: 1; font-weight: 400; font-size: 16px; }
  .yj-model-dialog .yj-model-hd .model-type { display: inline-flex; height: 26px; padding: 4px 8px; border-radius: 4px; color: #38f; background: #f3f5f7; display: flex; justify-content: center; align-items: center; cursor: pointer; transition: .3s; font-size: 16px; font-weight: 700; }
  .yj-model-dialog .yj-model-hd .closed { display: flex; place-items: center; place-content: center; font-size: 0; width: 32px; height: 32px; cursor: pointer; background-color: rgba(255, 255, 255, 0); border: none; outline: none; border-radius: 8px; fill: #444; transition: all 0.3s ease-out 0s; }
  .yj-model-dialog .yj-model-hd .closed:hover { background-color: #0000000f; }
  .yj-model-dialog .yj-model-hd .closed svg { width: 32px; }
  .yj-model-dialog .yj-model-bd { flex: 1; padding: 20px; }
  .yj-model-dialog .yj-model-bd .yj-model-bd_warp { }

  .yj-model-dialog .yj-model-bd .yj-model-panel { background-color: #f9f9f9; border: 0.5px rgba(0,0,0,.15) solid; border-radius: 6px; height: 100%; }
  .yj-model-dialog .yj-model-bd .yj-model-panel .code-layout { max-height: 560px; height: 100%; overflow: auto; scrollbar-color: #ececec transparent; padding: 15px; }
  .yj-model-dialog .yj-model-bd .yj-model-panel code { word-wrap: normal; background: none; -webkit-hyphens: none; hyphens: none; line-height: 1.5; tab-size: 4; white-space: pre-wrap; word-break: normal; word-spacing: normal; }
  .yj-model-dialog .yj-model-ft { display: flex; padding: 24px 28px; }

  .yj-model-dialog .yj-model-ft .operate { flex: 1; display: flex; place-content: center; place-items: center; }
  .yj-model-dialog .yj-model-ft .operate .file-btn { display: inline-block; width: 102px; height: 36px; line-height: 36px; text-align: center; background-color: #FBFBFB; color: #353535; border-radius: 3px; font-size: 14px; cursor: pointer; border: 1px #E4E8EB solid; }
  .yj-model-dialog .yj-model-ft .operate .file-btn:hover { background-color: #EFF0F2; color: #858585 }

  .ai-primary { color: #444; background-image: linear-gradient(var(--angle), #AAFC89, #00F9E5 44%, #2D60FF); border-radius: 20px; padding: 0 30px; display: flex; place-items: center; gap: 5px; transition: all 0.3s ease-in-out; }
  .ai-primary svg { width: 20px; height: 20px; }

  .ai-primary.ai-loading { animation: rotateGradient 5s linear infinite; }

  .empty-warp{  display: flex;place-content: center; place-items: center;height: 280px;}
  .empty-warp .empty-context{width: 80%; display: flex;place-content: center; place-items: center; flex-direction:column; text-align: center;}
  .empty-warp .empty-context .btn-list{margin-bottom: 25px;}
  .empty-warp .empty-tips h2{font-size: 24px; color: #444;}
  .empty-warp .empty-tips p{font-size: 16px; margin-top: 15px;}
  .empty-operate{margin-top: 50px;}
     @property --angle {
    syntax: "<angle>";
    inherits: false;
    initial-value: 17deg;
}

@keyframes rotateGradient {
   0% {
        --angle: 0deg;
    }
    100% {
        --angle: 360deg; /* 17° + 360° */
    }
}
</style>




// WEBPACK FOOTER //
// src/components/llmsTask/llmsTask.vue